module.exports = __webpack_public_path__ + "static/img/juhuaR404A.0a9301f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/juhua/juhuaR404A.jpg
// module id = St6E
// module chunks = 1